
import { ValidationObserver } from 'vee-validate';
import TextFieldWithValidation from '~/components/inputs/TextFieldWithValidation';
export default {
  name: 'ResetPage',
  components: {
    TextFieldWithValidation,
    ValidationObserver,
  },
  layout: 'authentication',
  data() {
    return {
      loading: false,
      email: '',
      requestSent: false,
    };
  },
  methods: {
    async requestPasswordReset() {
      try {
        this.loading = true;
        await this.$store.dispatch('user/resetPassword', {
          email: this.email.toLowerCase(),
        });
        this.requestSent = true;
      } catch (err) {
        this.$refs.obs.setErrors({
          email: err.message || 'Error sending password reset request',
        });
      } finally {
        this.loading = false;
      }
    },
  },
};
